module.exports = __webpack_public_path__ + "static/img/Recharge.3d181c48.png";